import React from 'react';

export function H1({ content, className, smallText, ...rest }) {
    return (
        <h1 className={className} {...rest}>
            {content}
            {smallText && <small>{smallText}</small>}
        </h1>
    )
}
